import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {

    public readonly router = inject(Router);

    private history: string[] = [];

    constructor() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                let url = event.urlAfterRedirects;
                if (url.includes('?')) {
                    url = url.substring(0, url.indexOf('?'));
                }

                if (url !== this.history[this.history.length - 1]) {
                    this.history.push(url);
                    this.history = this.history.slice(-20);
                }
            }
        });
    }

    public back(): void {
        this.history.pop();
        if (this.history.length > 0) {
            this.router.navigateByUrl(this.history.pop()!);
        } else {
            this.router.navigateByUrl('/');
        }
    }
}
